import React from 'react';
import './Portfolio.css';
import { frontendProjects, backendProjects } from '../../utils/Portfolio';
import { SiGithub } from 'react-icons/si';
import { BsPlay } from 'react-icons/bs';


function Portfolio() {
  return (
    <section id="portfolio">
      <h3>Alguns projetos</h3>
      <h2>Meu Portfolio</h2>

        <div className="projects-container">
          {
            frontendProjects.map(({ title, image, github, link }) => {
              return (
                <div className="project" key={ title }>
                  <img src={ image } alt={ title } className="project-img" />
                  <span className="project-title">{ title }</span>

                  <div className="buttons-container">
                    <a href={ github } target="_blank" rel="noreferrer">
                      <button type="button" className="project-btn">
                        <SiGithub />
                        <span className="btn-text">Repositório</span>
                      </button>
                    </a>

                    <a href={ link } target="_blank" rel="noreferrer">
                      <button type="button" className="project-btn">
                        <BsPlay />
                        <span className="btn-text">Deploy</span>
                      </button>
                    </a>

                  </div>
                </div>
              )
            })
          }
          {
            backendProjects.map(({ title, image, github }) => {
              return (
                <div className="project" key={ title }>
                  <img src={ image } alt={ title } className="project-img" />
                  <span className="project-title">{ title }</span>

                  <div className="buttons-container">
                    <a href={ github } target="_blank" rel="noreferrer">
                      <button type="button" className="project-btn">
                        <SiGithub />
                        <span className="btn-text">Repositório</span>
                      </button>
                    </a>
                  </div>
                </div>
              )
            })
          }
        </div>
    </section>
  )
}

export default Portfolio;
